module.exports = __webpack_public_path__ + "img/right-front.a7c0173c.png";